import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import registerServiceWorker from "./serviceWorker";
import { QueryClient, QueryClientProvider } from "react-query";

// style
import "./assets/css/main.css";
const client = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			refetchOnMount: true,
		},
	},
});
const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement
);

root.render(
	// <React.StrictMode>
	<QueryClientProvider client={client}>
		<App />
	</QueryClientProvider>
	// </React.StrictMode>
);

registerServiceWorker();
